// extracted by mini-css-extract-plugin
module.exports = {"motif_statistics_tile":"styles_motif_statistics_tile__3JOXd","data_section":"styles_data_section__2yfXu","course_title":"styles_course_title__2-Nfs"};